import { render, staticRenderFns } from "./MenuBarAccountModal.vue?vue&type=template&id=6e349586&"
import script from "./MenuBarAccountModal.vue?vue&type=script&lang=js&"
export * from "./MenuBarAccountModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports